// timelineService.js
import axios from 'axios';
import Config from 'Config';
import { createSignedRequest } from 'utils/createSignedRequest';

export const getTimelinesForBusinessService = async (businessId, projectId, lastEvaluatedKey = null) => {
  const host = process.env.REACT_APP_WORK_CALENDAR_API_URL;
  const apiPath = `timelines/project/${projectId}/get-timelines-for-business`;

  const body = {
    businessId,
    lastEvaluatedKey,
  };

  const request = {
    // url: `http://localhost:3001/${apiPath}`,
    url: `https://${process.env.REACT_APP_WORK_CALENDAR_API_URL}/${apiPath}`,
    host: host,
    path: apiPath,
    method: 'POST',
    region: Config.AWS_REGION,
    service: 'execute-api',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
    data: body,
  };

  const signedRequest = await createSignedRequest(request);

  const response = await axios(signedRequest);

  return response.data;
};
